exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/*\n  Stylesheet for the page for searching for reference projects.\n  @author Adrian Rebmann, Yannik Sprengart\n*/\n.margin-twenty[data-v-a31fa742] {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.no-link[data-v-a31fa742] {\n  text-decoration: none !important;\n}\n", "", {"version":3,"sources":["/home/gitlab-runner/builds/3bb37404/0/mkz/werner-frontend/src/components/search/referenceprojectsearch/query/referenceprojectsearch.css"],"names":[],"mappings":"AAAA;;;EAGE;AAEF;EACE,iBAAiB;EACjB,oBAAoB;CACrB;AAED;EACE,iCAAiC;CAClC","file":"referenceprojectsearch.css","sourcesContent":["/*\n  Stylesheet for the page for searching for reference projects.\n  @author Adrian Rebmann, Yannik Sprengart\n*/\n\n.margin-twenty {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.no-link {\n  text-decoration: none !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a31fa742","scoped":true,"hasInlineConfig":false}!./src/components/search/referenceprojectsearch/query/referenceprojectsearch.css
// module id = gNET
// module chunks = 1